import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import {IGridCustomizedColumnsModel} from 'src/models/IGridCustomizationModel';
import {OPPORTUNITIES_API_PATHS} from '../constants/constants';
import axios from '../utils/APIUtils';


export const initialState = {
    gridCustomizationOptions : [] as IGridCustomizedColumnsModel[],
};

export const gridCustomizationSlice = createSlice({
    name: 'gridCustomization',
    initialState,
    reducers: {
      setGridCustomizationOptions: (state,action) => {
        state.gridCustomizationOptions = action.payload;
      }
    }
  });

  /**Get Grid Customization API calls */

export const getGridCustomizationList = async (data:any) => {
    return await axios.get<any>
        (`${OPPORTUNITIES_API_PATHS.gridCustomization}?current_role=${data}`)
        .then((response) => {
            return response.data;
    }).catch(err => {
        console.error('Grid Option API error ', err);
        throw err;
    });
  };


  /**Update/Post Grid Customization API call*/

export const updateGridCustomizationColumns= async (data:any) => {
    return await axios.post<any>
        (`${OPPORTUNITIES_API_PATHS.gridCustomizationUpdate}`,data)
        .then((response) => {
            return response.data;
    }).catch(err => {
        console.error('Grid Option API error ', err);
        throw err;
    });
  };


  export const {  setGridCustomizationOptions } = gridCustomizationSlice.actions;
  export const getGridCustomizationOptions= (state: RootState) => state.gridCustomization.gridCustomizationOptions;
  export default gridCustomizationSlice.reducer;